import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuthContext } from '../../../features/auth/context/AuthContext';
import { canManageOrganization } from '../../../utils/planPermissions';
import BillingSection from '../../../features/profile/sections/BillingSection';

/**
 * Billing tab content for AccountModal. Wraps BillingSection with access check.
 */
function BillingTab() {
  const { user } = useAuthContext();
  const [userRole, setUserRole] = useState(() => localStorage.getItem('userRole') || 'member');
  const [roleLoaded, setRoleLoaded] = useState(false);

  useEffect(() => {
    if (!user?.id) {
      setRoleLoaded(true);
      return;
    }
    const fetchUserRole = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setRoleLoaded(true);
          return;
        }
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/organization/my-role`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const role = data.role || 'member';
        setUserRole(role);
        localStorage.setItem('userRole', role);
      } catch (error) {
        console.error('Error fetching user role:', error);
        setUserRole('member');
      } finally {
        setRoleLoaded(true);
      }
    };
    fetchUserRole();
  }, [user?.id]);

  if (!roleLoaded) {
    return (
      <div className="flex-1 min-h-0 overflow-y-auto px-4 py-4 flex items-center justify-center">
        <p className="text-gray-500 dark:text-[#999999]" style={{ fontFamily: 'var(--chat-font-family)' }}>
          Loading...
        </p>
      </div>
    );
  }

  const usePlaceholders = process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEV_BILLING_PLACEHOLDERS !== 'false';
  if (!usePlaceholders && !canManageOrganization(user, userRole)) {
    return (
      <div className="flex-1 min-h-0 overflow-y-auto px-4 py-4 flex flex-col items-center justify-center text-center">
        <p className="text-gray-500 dark:text-[#999999]" style={{ fontFamily: 'var(--chat-font-family)' }}>
          Only organization administrators and owners can access billing information.
        </p>
      </div>
    );
  }

  return (
    <div className="flex-1 min-h-0 overflow-y-auto px-4 py-4" style={{ fontFamily: 'var(--chat-font-family)' }}>
      <BillingSection embedded />
    </div>
  );
}

export default BillingTab;
